import { InputNumber, Slider, SliderProps } from '@arco-design/web-react';
import { ReactNode, useEffect, useState } from 'react';

/** SliderInput 组件, 所有的状态属性与 Arco 组件保持一致 */
interface SliderInputProps extends SliderProps {
  /** 额外后缀 */
  suffix?: ReactNode;
}
export function SliderInput(props: SliderInputProps) {
  const {
    min = 0,
    max = 100,
    marks,
    value,
    onChange,
    showInput = true,
    suffix,
    ...restProps
  } = props;

  const [innerValue, setInnerValue] = useState<number>(Number(value));

  // 同步外部 value
  useEffect(() => {
    setInnerValue(Number(value));
  }, [value]);

  // 拖动条变化
  const handleSliderChange = (val: number) => {
    setInnerValue(val);
    onChange?.(val);
  };

  // 输入框变化
  const handleInputChange = (val: number) => {
    if (val < min) {
      val = min;
    }
    if (val > max) {
      val = max;
    }
    setInnerValue(val);
    onChange?.(val);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'start', gap: 16 }}>
      <Slider
        min={min}
        max={max}
        marks={marks}
        value={innerValue > max ? max : innerValue}
        onChange={handleSliderChange}
        {...restProps}
      />
      {showInput && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <InputNumber
            value={innerValue}
            onBlur={(e) => handleInputChange(Number(e.target.value || min || 0))}
            style={{ width: '6rem' }}
          />
          {suffix && <span>{suffix}</span>}
        </div>
      )}
    </div>
  );
}
